export const FILTERS_LOCAL_STORAGE_KEYS = {
  WORK_AT_HOME: 'WORK_AT_HOME',
  VALIDATION_TIMEKEEPING: 'VALIDATION_TIMEKEEPING',
  INVOICED: 'INVOICED',
  PEOPLE_FILTER_TYPE: 'PEOPLE_FILTER_TYPE',
  CUSTOM_PEOPLE_FILTER: 'CUSTOM_PEOPLE_FILTER',
  CUSTOM_PEOPLE_SAVED_SELECTION: 'CUSTOM_PEOPLE_SAVED_SELECTION',
};
